<template>
  <div class="flex-grow-1">
    <header-bar />
    <v-card>
      <v-card-text class="ml-4">
        <div class="h1 mb-2">User Agreement & Disclaimer / Terms of Use</div>
        <div class="ml-4">
          <div class="h2 my-2">
            PLEASE READ THESE TERMS AND CONDITIONS CAREFULLY BEFORE USING THIS
            SITE.
          </div>
          <div class="body mb-2">
            Access to and use of this site are governed by the following terms
            and conditions and all applicable laws. Please review these terms
            periodically, as they may be modified, altered, or updated at any
            time at the sole discretion of Sigflō. If you do not agree to any
            term or condition, you should not use this site.
          </div>
          <div class="h2">I. Restrictions on Use</div>
          <div class="body">
            By using the website, you agree that the following actions will
            constitute a material breach:
          </div>
          <div class="body mb-2">
            <ul>
              <li>
                Collecting information about the website or its users without
                our written permission.
              </li>
              <li>
                Changing, framing, reflecting, shortening, injecting, filtering,
                or altering any content or information on the website without
                our written consent.
              </li>
              <li>
                Using any deep-link, page-scrape, robot, crawl, index, spider,
                click spam, macro programs, Internet agent, or other automated
                devices to access, copy, obtain information, generate
                impressions or clicks, input information, store information,
                search, or monitor the website or any part of it.
              </li>
              <li>
                Using the site for competitive or commercial purposes other than
                transactions with Sigflō.
              </li>
              <li>
                Concealing the origin of information transmitted to, from, or
                through the website.
              </li>
              <li>Impersonating another individual.</li>
              <li>Distributing viruses or other harmful computer code.</li>
              <li>
                Allowing any other person or entity to impersonate you to access
                or use the website.
              </li>
              <li>
                Using the website for any purpose that violates local, state,
                national, or international laws.
              </li>
              <li>
                Using the website in a way intended to cause harm, or that a
                reasonable person would understand likely results in harm, to
                the user or others.
              </li>
              <li>
                Circumventing any measures we have put in place to prevent
                violations of these Terms of Use
              </li>
            </ul>
          </div>
          <div class="h2">II. Third-Party Sites</div>
          <div class="body mb-2">
            Sigflō may provide links and pointers to internet sites maintained
            by third parties ("third-party sites") and may provide materials
            from third parties on this website. These are provided for your
            convenience only. Sigflō does not operate or control any
            information, products, or services available on these third-party
            sites and is not responsible for their content. Sigflō makes no
            representations about the content of these sites, and the fact that
            Sigflō has provided a link to them is not an endorsement,
            authorization, sponsorship, or affiliation with respect to such
            sites, their services, products, owners, or providers. You access
            these sites at your own risk. For more details on data privacy and
            how your personal information might be collected, stored, and used
            by Sigflō, please see our Data Privacy Policy.
          </div>
          <div class="h2">III. Disclaimer</div>
          <div class="body mb-2">
            <p>
              There are certain risks in using any information, software, or
              products found on the internet; Sigflō advises you to fully
              understand these risks before retrieving, using, relying upon, or
              purchasing anything via the internet. Visitors to this website
              assume all responsibility and risk for its use. Information
              published on this website is provided without charge as a
              convenience to visitors, to be used for informational purposes
              only. NOTHING ON THIS WEBSITE CONSTITUTES A RECOMMENDATION OR
              ENDORSEMENT OF ANY ITEM, PRODUCT, OR BRAND.
            </p>
            <p>
              ALTHOUGH REASONABLE CARE HAS BEEN TAKEN REGARDING THIS SITE'S
              CONTENT, SIGFLŌ DOES NOT WARRANT OR REPRESENT THAT THIS SITE'S
              CONTENT IS ACCURATE, COMPLETE, OR UP TO DATE, NOR DOES IT WARRANT
              OR REPRESENT THAT ACCESS TO AND USE OF THIS SITE OR THE SERVER
              MAKING IT AVAILABLE WILL BE UNINTERRUPTED, ERROR-FREE, AND FREE OF
              COMPUTER VIRUSES OR OTHER HARMFUL COMPONENTS. THE CONTENT OF THIS
              SITE MAY INCLUDE TECHNICAL INACCURACIES OR TYPOGRAPHICAL ERRORS
              FOR WHICH SIGFLŌ ASSUMES NO RESPONSIBILITY.
            </p>
            <p>
              ALL MATERIALS PROVIDED HEREIN, INCLUDING MATERIALS AVAILABLE ON
              THIRD-PARTY SITES, ARE PROVIDED ON AN "AS IS" AND "AS AVAILABLE"
              BASIS WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED.
              TO THE FULLEST EXTENT PERMISSIBLE UNDER APPLICABLE LAW, SIGFLŌ
              DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING BUT NOT
              LIMITED TO IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
              PARTICULAR PURPOSE, TITLE, AND NON-INFRINGEMENT.
            </p>
          </div>
          <div class="h2">IV. Limitation of Liability</div>
          <div class="body mb-2">
            <p>
              Sigflō is not responsible for any infections, contaminations,
              delay in operation or transmission, line failure, errors,
              omissions, interruptions, or defects arising out of your use of
              this site or concerning the material provided and/or contained on
              this site.
            </p>
            <p>
              In no event shall Sigflō be liable for any special, direct,
              indirect, incidental, or consequential damages, or any other
              damages of any kind, including but not limited to loss of use,
              loss of profits, or loss of data, whether in an action under
              theories of contract, negligence, strict liability, or otherwise,
              arising out of or in connection with the use of or inability to
              use the information or materials on, or purchased from, or
              accessed through, the Sigflō website.
            </p>
            <p>
              Notwithstanding the above, in no event shall Sigflō's total
              liability to you for any and all claims, damages, losses, and
              causes of action exceed the amounts paid to Sigflō by you in
              connection with the transaction giving rise to your claim.
            </p>
          </div>
          <div class="h2">V. Communications and Submissions</div>
          <div class="body mb-2">
            <p>
              By transmitting or posting any submissions to Sigflō or this
              website, you grant Sigflō and its affiliates a non-exclusive,
              royalty-free, perpetual, irrevocable, and fully sublicensable
              right to use the content of such submissions for any purpose,
              including but not limited to reproducing, modifying, adapting,
              publishing, translating, creating derivative works from,
              distributing, and displaying such content throughout the world in
              any media. You also grant Sigflō and its affiliates and
              sublicensees the right, at their sole discretion, to use the name
              you submit in connection with such content. You agree that the
              license granted herein includes all rights to use or authorize the
              use of any ideas, concepts, know-how, or techniques contained in
              such submissions for any purpose, including developing,
              manufacturing, and marketing products or services incorporating
              such information.
            </p>
            <p>
              You represent and warrant that you own or otherwise control all
              rights to the content of your submissions; that the content is
              accurate; that use of the content you supply does not violate any
              terms of this User Agreement and will not cause injury to any
              person or entity; and that you will indemnify Sigflō or its
              affiliates for all claims resulting from content you supply. You
              agree that neither Sigflō nor its licensees will be liable to you
              for any use of any submission. Sigflō has the right but not the
              obligation to monitor and edit or remove any activity or content.
            </p>
            <p>
              You acknowledge and agree that you are solely responsible for any
              submissions you submit to Sigflō or this website and further agree
              that you, not Sigflō, have full responsibility for the content of
              any such submissions, including their legality, reliability, and
              appropriateness.
            </p>
          </div>
          <div class="h2">VI. Jurisdiction and Choice of Law</div>
          <div class="body mb-2">
            <p>
              Sigflō operates this website from its offices in Bradenton,
              Florida, USA. Sigflō makes no representations that the materials
              on this site are appropriate or available for use in other
              locations. Those who choose to access this website from other
              locations do so at their own risk and are responsible for
              compliance with any applicable local laws.
            </p>
            <p>
              This agreement, and any dispute arising from this website, shall
              be construed under the laws of the state of Florida. Any legal
              action regarding this agreement or this website shall be brought
              only in the state or federal courts located in Bradenton, Florida,
              and by using this site, you consent to personal jurisdiction
              within these courts
            </p>
          </div>
          <div class="h2">VII. Inquiries</div>
          <div class="body mb-2">
            <p>
              If you have any questions about this Agreement or wish to inquire
              about rights of use not explicitly granted herein, please contact
              support@sigflo.com.
            </p>
          </div>
          <div class="h2">VIII. Termination</div>
          <div class="body mb-2">
            <p>
              Sigflō or you may terminate this Agreement at any time. You may
              terminate this Agreement by destroying all materials obtained from
              this website. Sigflō may terminate this Agreement immediately
              without notice if, in its sole judgment, you breach any term or
              condition of this Agreement. Upon termination, you must destroy
              all materials obtained from this website.
            </p>
          </div>
          <div class="h2">IX. Integration</div>
          <div class="body mb-2">
            <p>
              This Agreement constitutes the entire agreement between you and
              Sigflō and supersedes any prior oral or written agreements,
              understandings, or other communications between the parties. This
              Agreement may not be modified except in writing signed by both you
              and an authorized signatory of Sigflō.
            </p>
          </div>
          <div class="h2">X. Other</div>
          <div class="body mb-2">
            <p>
              The headings in this Agreement are for reference purposes only and
              have no legal effect. If any portion of this Agreement is void or
              unenforceable in whole or in part, the remaining provisions shall
              remain in effect.
            </p>
          </div>
          <div class="h2">XI. Export Disclaimer</div>
          <div class="body mb-2">
            <p>
              Items sold by Sigflō are subject to U.S. export control laws and
              regulations, including the Export Administration Regulations and
              the International Traffic in Arms Regulations, and may require a
              license or other authorization from the U.S. government to be
              exported from the United States. Without limitation, parties
              purchasing from Sigflō are solely responsible for determining
              applicable export licensing requirements and for obtaining any
              necessary licenses or other authorizations from the appropriate
              U.S. government agencies, such as the U.S. Department of Commerce
              or the U.S. Department of State.
            </p>
          </div>
          <div class="h2">XII. Pricing Disclaimer</div>
          <div class="body mb-2">
            <p>
              All pricing on Sigflō is subject to change. Our Minimum Advertised
              Price (MAP) will be updated on a constant basis. Please note that
              pricing is not guaranteed until the purchase is complete with
              payment. We strive to provide accurate pricing information, but
              occasionally, pricing or typographical errors may occur. In the
              event of a pricing error, we reserve the right to cancel any
              orders placed with incorrect pricing.
            </p>
            <p>
              Privacy Policy: Please find our
              <RouterLink to="/privacy">privacy policy here.</RouterLink>
            </p>
            <p>
              Version History: Version 1.0 Initial Agreement date: July 22,
              2024.
            </p>
          </div>
        </div>
      </v-card-text>
    </v-card>
    <footer-bar />
  </div>
</template>

<script>
  import headerBar from '@/components/shared/HeaderBar.vue';
  import footerBar from '@/components/shared/FooterBar.vue';

  export default {
    components: {
      headerBar,
      footerBar
    }
  };
</script>

<style scoped>
  .h1 {
    color: black;
    font-size: 2rem;
    line-height: 2;
    font-weight: bold;
  }
  .h2 {
    font-size: 1rem;
    font-weight: bold;
    color: black;
  }
  .body {
    font-weight: normal;
    font-size: 0.875rem;
    color: rgba(0, 0, 0, 0.7);
  }
</style>
